import React from "react";
import { useAppSelector } from "../../../../app/redux/hooks";
// import HistoricalPriceChart from "./HistoricalPriceChart";
import { MemoizedHistoricalPriceChart } from "./HistoricalPriceChart";

function HistoricalPriceChartContainer() {
  const { chartData } = useAppSelector((state) => state.drp);
  return (
    <div
      className="modal fade"
      id="chartModal"
      tabIndex={-1}
      aria-labelledby="chartModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5
              className="modal-title"
              id="chartModalLabel"
              style={{ fontSize: 30 }}
            >
              {`${chartData.product} - ${chartData.quarter}`}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <MemoizedHistoricalPriceChart />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoricalPriceChartContainer;
